function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#close_svg__clip0_8836_45067)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.3 6.148a.992.992 0 00-1.41 0L12 11.057 7.11 6.138a.992.992 0 00-1.41 0 1.006 1.006 0 000 1.418l4.89 4.92-4.89 4.918a1.006 1.006 0 000 1.419.992.992 0 001.41 0l4.89-4.92 4.89 4.92a.992.992 0 001.41 0c.39-.392.39-1.026 0-1.419l-4.89-4.919 4.89-4.919c.38-.382.38-1.026 0-1.408z",
  fill: "current"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "close_svg__clip0_8836_45067"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .402)",
  d: "M0 0h24v24.142H0z"
})));

function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgClose;